/* eslint-disable  @typescript-eslint/no-explicit-any */
import type { MiddlewarePipeDetails } from '../../models/middleware-pipe-details.model';
import type {PipeMiddlewareElement, PipeMiddlewareNext} from '../../middleware-pipe';
import type { ResultResponseDto } from '../../../../models/cose-api/response/result-response.dto';
import i3DocumentsMap from '../../../mappers/i3/i3-documents-mapper';
import type { SearchTab } from '../../../../components/result-page/search-tab/search-tab';
import { makeLogger } from '../../../../logger/logger';
import type {DashboardMisspellings} from '../../../../components/result-page/search-tab/subcomponents/dashboard-tab-view/dashboard-misspellings/dashboard-misspellings';

const { debug } = makeLogger({
  pathToCurrentFile:'utils/middleware-pipe/pipes/cose/res-cose-documents-mapping.ts',
  loggersList: ['debug']
});

export const resCoseDocumentsMapping: PipeMiddlewareElement<any, any> = async (
  details: MiddlewarePipeDetails,
  next: PipeMiddlewareNext<any>,
  middlewareDepth: number,
  middlewareArray: Array<PipeMiddlewareElement<MiddlewarePipeDetails, any>>
) => {
    const searchTab: SearchTab | DashboardMisspellings = details.context;

    debug('responseCoseDocumentsMap BEFORE',details);
    const response = await next(details) as ResultResponseDto<any>;
    const newResponse = {...response};
    if(newResponse.documents?.length > 0){
      newResponse.documents = [...i3DocumentsMap(response.documents, {language: searchTab.language, country: searchTab.country})];
      newResponse.documents.map(document => {
          if(!Array.isArray(document.docLocale)){
            document.docLocale = [document.docLocale];
          }
      });
    }

    debug('responseCoseDocumentsMap AFTER',newResponse);
    return new Promise(r=>r(newResponse));
};
